import { render, staticRenderFns } from "./user-menu-item.vue?vue&type=template&id=5ff1b6e5&scoped=true"
import script from "./user-menu-item.vue?vue&type=script&lang=js"
export * from "./user-menu-item.vue?vue&type=script&lang=js"
import style0 from "./user-menu-item.vue?vue&type=style&index=0&id=5ff1b6e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1b6e5",
  null
  
)

export default component.exports